exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-toast{display:block;color:#fff}adp-toast.panel-dark{padding:12px}adp-toast.hidden{display:none}adp-toast div.toast-content>div.col{display:flex;flex-flow:wrap}adp-toast p{margin-bottom:2px;font-size:16px;font-family:ProximaNova-Regular,Arial,Helvetica,sans-serif;font-size:14px;color:#fff}adp-toast p:last-of-type{margin-bottom:0}adp-toast p span.bold{padding-right:4px}adp-toast [class^=col]{display:flex;padding:0}adp-toast [class^=col].close-btn{margin-top:-15px 0 0 0;padding:0 0 0 10px;font-size:10px}adp-toast [class^=col].close-btn:hover{cursor:pointer}adp-toast .toast-wrap{position:relative;color:#fff;transition:all .5s ease}adp-toast .toast-wrap .toast-content{margin:0}adp-toast .toast-wrap .material-icons.md-14{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpToast/adpToast.less
// module id = 642
// module chunks = 0